import { RegisterOptions } from 'react-hook-form';

export const zipMinLength = ( message: string ): RegisterOptions['minLength'] => {
  return {
    value: 5,
    message,
  };
};
